/**
 * useIsAdmin — реактивный признак «текущий пользователь — оператор-админ»
 * для FE-навигации вне админ-панели (сейчас: гейт каталога наставников).
 *
 * Источник истины — тот же, что у /admin-*-роутов: /admin-api/me/ (суперюзер
 * или любая admin.*-группа) через Pinia-стор `useAdminMeStore`. Пробник
 * подгружаем один раз для ЗАЛОГИНЕННОГО пользователя (для анонима не дёргаем —
 * он заведомо не админ). Ответ 403 у не-админа тихий (см. fetchAdminMe →
 * suppressErrorToast) и кэшируется в сторе (accessDenied), так что повторных
 * запросов и «мигающих» тостов нет.
 */
import { computed, watch, type ComputedRef } from 'vue';
import { useAdminMeStore } from '@/admin/entities/me/store';
import store from '../../store';

export function useIsAdmin(): ComputedRef<boolean> {
    const adminMe = useAdminMeStore();

    // immediate — покрывает «тёплый» старт (пользователь уже в сторе);
    // реакция на смену isAuthenticated — «холодный» старт (fetchUser
    // дорезолвится позже). Гард по me/accessDenied/loading исключает
    // повторные и параллельные загрузки (несколько потребителей composable).
    watch(
        () => store.getters.isAuthenticated as boolean,
        (isAuthenticated) => {
            if (
                isAuthenticated &&
                !adminMe.me &&
                !adminMe.accessDenied &&
                !adminMe.loading
            ) {
                void adminMe.load();
            }
        },
        { immediate: true },
    );

    return computed(() => adminMe.isAdmin);
}
